import React,{useState, useEffect} from "react";
import { Link, useNavigate } from 'react-router-dom'
import axios from "axios";
import { api, eventURL } from "../../../apis/urls";
import Loader from "../../../common-components/loader";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactPaginate from 'react-paginate';
import { $ } from "react-jquery-plugin";
import { decode } from "html-entities";
import moment from "moment/moment";
import { Table, Toggle,Pagination } from "rsuite";
import { Fragment } from "react-read-more-read-less";
import { message } from "antd";

const { Column, HeaderCell, Cell } = Table;

const EventComponent = () => {

    const [added, setAdded] = useState(false);
    const [publish, setPublish] = useState('');

    const [pageno, setPageno] = useState(0);

    let navigate = useNavigate();


    useEffect(() => {
        $('html,body').animate({ scrollTop: 0 }, 'fast');
        setLoader(true);
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        setTimeout(() => {
            Listing();
            });

            const role = localStorage.getItem('userrole');
            if(role ==="SUPERADMIN"){
                Listing();
            }else{
                message.success('You are not authorized to perform this action.');
                navigate('/admin')
            }


    }, []);

    const [loader,setLoader] = useState(true);
    const [result,setResult] = useState([]);
    const [searchTitle, setSearchTitle] = useState("");
    const [alertText, setAlertText]=useState("");
    const [currentpage, setCurrentpage] = useState([]);
    const [totalPages, setTotalPages] = useState([]);
    const [totalItems, setTotalItems] = useState([]);
    const [emptyItem, setEmptyItem] = useState(false);


    let counts = 0;
    if(result)
    {
        counts = result.length;
    }



    const Listing = () => {

        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: eventURL+'?page='+pageno+'&size='+10,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            if(response.data.message === "Success"){            
                console.log("current page ===>", response.data.currentPage);
                setResult(response.data.data.sort((a, b) => b.createdAt.localeCompare(a.createdAt)));
                setCurrentpage(response.data.currentPage)
                setTotalPages(response.data.totalPages)
                setTotalItems(response.data.totalItems)
                setLoader(false)
                }else{
                setResult(false);
                setLoader(false);
            }

           
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
    }


    const PublishStatusSubmit = (id) => {

        let token = "Bearer "+localStorage.getItem('token');
        const instance = axios.create({
            baseURL: eventURL+'/publish/'+id,
            timeout: 1000000,
            headers: {'authorization': token}
          });
          instance.patch('').then((response) =>{

            // window.location.reload();
            Listing();

            setPublish(response.data.publish_status)
            console.log("Success", response.data)
          }).catch((error) =>{   
            console.log('error',error.message)  
          });
    }



        let token = "Bearer "+localStorage.getItem('token');
        const instances = axios.create({
            baseURL: api,
            timeout: 1000000,
            headers: {'authorization': token}
        });

        const findByTitles = name => {
            return instances.get(`cm/event?search=${name}`);
        };

        const onChangeSearchTitle = (e) => {
            const searchTitle = e.target.value;
            setSearchTitle(searchTitle);
            findByTitles(searchTitle)
            .then(response => {
                if(response.data.message=== "Success"){
                    setResult(response.data.data)
                    
                }else{
                    setResult(false)
                }
            })
            .catch(e => {
                console.log(e);
            });
        };

        const findByTitlesss = option => {
            return instances.get(`cm/event?status=${option}`);
        };

        const onChangeSearchTitles = (e) => {
            const searchTitle = e.target.value;
            findByTitlesss(searchTitle)
            .then(response => {
                if(response.data.message=== "Success"){
                    setResult(response.data.data)
                }else{
                    setResult(false)
                }
            })
            .catch(e => {
                console.log(e);
            });
        };


    //PAGINATION


     // Invoke when user click to request another page.
     const handlePageClick = (event) => { console.log('EVENTSSS',event)

     $('html,body').animate({ scrollTop: 0 }, 'fast');


     setPageno(event.selected)
     const instance = axios.create({
         baseURL: eventURL+'?page='+event.selected+'&size='+10,
         timeout: 1000000,
         headers: {'authorization': token}
     });

     instance.get('').then(res => {

         setResult(res.data.data)
         setCurrentpage(res.data.currentPage)
         setTotalPages(res.data.totalPages)
         setTotalItems(res.data.totalItems)
         setLoader(false);

     }).catch(e => {
        localStorage.removeItem('token')
     navigate("/")
     });
 };

 let dates = new Date();



    let sl =1;
    return (
        <div className="wrapper">
            <aside className="right-side ">
                <div class="content-area">
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            <i className="icon-suitcase1"></i>
                            <h2 className="page-title">Seminar</h2>
                        </div>

                        <div class="page-rightside-action-column">
                            <div class="input-groups mt-3 mb-3 search-grps">
                            <input type="text" 
                            class="form-controls search-bar asso-search"             
                            value={searchTitle}
                            onChange={onChangeSearchTitle}
                            placeholder="Search" />
                            <button  class="btn btn-search icon-search assosearch-btn"></button>
                            </div>
                            <Link to="/add_event" data-toggle="tooltip" title="" class="addbtnitem-link text-anchor" data-original-title="Add New Event"><i class="icon-add"></i><span>Add New Event</span> </Link>
                        </div>

                    
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            
                            <li className="breadcrumb-item active" aria-current="page">Seminar</li>
                        </ol>
				    </nav>

                        {result?
                        (<div class="number-of">
                            Displaying 1-{counts} of {totalItems} results.
                        </div>):null
                        }


                    <div className="jobs-list-wrpr list-wrpr" >

                        {result?(
                        result?.map((item,index) =>
                            (
   
                                <>


                                <div className="list "  style={{background:item.publish_status === 'UNPUBLISHED'?'#f0f0f0':'#fff'}}>
                                    <div className="row">
                                        <div className="col-md-1">
                                        <div class="jobs-user">
                                        <span class="desig">Sl.No</span>
                                        {(index+1)+currentpage*10}
                                        </div>
                                        </div>
                                        
                                        <div className="col-md-2">
                                            <div className="jobs-user">
                                            <span class="desig"> Title</span>

                                            {decode(item.title)}
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="jobs-user">
                                            <span class="desig">Time and Location</span>
                                                 {moment(item.start_date).format('MMMM DD, YYYY')}, {moment(item.start_date).format('hh:mm a')}, {item.location}<br />
                                                {item.city}, {item.state}
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="jobs-user" data-toggle="tooltip" title="total number of paid and unpaid registrations">
                                            <span class="desig">Registrations</span>
                                                 {item.totalregistrants}  
                                        
                                            </div>
                                        </div>


                                    
                                        <div className="col-md-3" style={{marginTop:'10px'}}>
                                            <div className="list-action-wrpr text-right  roundicons-text event-btns">

                                                <Link  to={"/view_event/"+item.id} data-toggle="tooltip" title="View" ><i className="edit icon-eye" style={{background:'rgb(94, 186, 125)'}}></i><span>View</span></Link>  

                                                
                                                <button onClick={()=>{navigate("/register_details/"+item.id)}} style={{backgroundColor:'transparent' }}  data-toggle="tooltip" title="Number of paid registration" ><a><i className="delete icon-user2 data-counts-icon" data-count={item.attendee_count} style={{background:'#ff577f'}}></i><span>Attendee</span></a></button>

                                                

                                                {/* <button  to={"/register_details/"+item.id} data-toggle="tooltip" title="View"><i className="edit icon-user2" style={{background:'#ff577f'}}></i><span style={{textAlign:'center'}}><a>Registration</a></span></button>                                     */}
                                                {
                                                item.publish_status === 'UNPUBLISHED'? 
                                            
                                                    ( 

                                                        <button style={{backgroundColor:'transparent', paddingLeft:'10px' }}  data-toggle="tooltip" title="publish" onClick={(e) => { PublishStatusSubmit(item.id) }} ><a><i className="delete icon-publish"></i><span>Publish</span></a></button>
                                                    ) :
                                                    (
                                                        <button disabled data-toggle="tooltip" title="unpublish" style={{backgroundColor:'transparent', paddingLeft:'10px'}} onClick={(e) => { PublishStatusSubmit(item.id) } }  ><a><i className="delete icon-tick" style={{background:'#0069FF'}}></i><span>Published</span></a></button>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                           
                           
                           
                           )

                        )):null
                        }
                        {
                            !result?
                            (<div className="nodata">
                                <h2>Sorry! No Result Found</h2>
                            </div>):null
                        }
                        {result?

                        (<div class="number-of footer-number">
                            Displaying 1-{counts} of {totalItems} results.
                        </div>):null
                        }
    
                    </div>

                    { 
                        loader?
                        <div>
                            <div className="loader_container"><Loader/></div>
                        </div>
                        :
                        null
                    }

                    {result?(
                    <div class="pagination-wrpr">
                            <ReactPaginate
                                className="pagination page"
                                pageClassName="page-item"
                                activeClassName="active"
                                nextLabel=">"
                                previousLabel="<"
                                previousClassName="page-link p-link"
                                nextClassName="page-link p-link"
                                onPageChange={handlePageClick}
                                pageRangeDisplayed={10}
                                pageCount={totalPages}
                                renderOnZeroPageCount={1}
                            />
                        </div>):null
                        } 


                </div>
            </aside>
        </div>
    )
}

export default EventComponent;